/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { subnetsGetApiV3SubnetsSubnetId } from "../../funcs/subnetsGetApiV3SubnetsSubnetId.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3SubnetsSubnetIdRequest$inboundSchema,
};

export const tool$subnetsGetApiV3SubnetsSubnetId: ToolDefinition<typeof args> =
  {
    name: "subnets-get-api-v3-subnets-subnet-id",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await subnetsGetApiV3SubnetsSubnetId(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
